import request from '@/utils/request'

export function getOrgList (params, requestOptions) {
  return request(Object.assign({
    url: '/api/v1/organizations',
    method: 'get',
    params
  }, requestOptions || {}))
}

export function normalizeOrgListResponse (response) {
  if (!response || typeof response !== 'object' || !Array.isArray(response.list)) {
    throw new TypeError('组织列表响应格式错误：缺少 list 数组')
  }
  if (typeof response.total !== 'number' || !Number.isFinite(response.total) || response.total < 0) {
    throw new TypeError('组织列表响应格式错误：total 必须是非负数字')
  }

  const list = response.list.map((organization, index) => {
    if (!organization || typeof organization !== 'object') {
      throw new TypeError(`组织列表响应格式错误：list[${index}] 不是对象`)
    }
    if (!Number.isFinite(Number(organization.id)) || Number(organization.id) <= 0) {
      throw new TypeError(`组织列表响应格式错误：list[${index}].id 无效`)
    }
    if (typeof organization.name !== 'string' || !organization.name.trim()) {
      throw new TypeError(`组织列表响应格式错误：list[${index}].name 无效`)
    }
    if (organization.users !== undefined && organization.users !== null && !Array.isArray(organization.users)) {
      throw new TypeError(`组织列表响应格式错误：list[${index}].users 不是数组`)
    }

    return Object.assign({}, organization, {
      users: organization.users || []
    })
  })

  return {
    list,
    total: response.total
  }
}

// 筛选器加载失败应由当前页面局部展示，不触发全局错误提示。
export function getOrganizationOptions () {
  return getOrgList({ include_users: 1 }, { suppressErrorMessage: true }).then(normalizeOrgListResponse)
}

export function addOrg (data) {
  return request({
    url: '/api/v1/organizations',
    method: 'post',
    data
  })
}

export function getOrgDetail (id) {
  return request({
    url: '/api/v1/organizations/' + id,
    method: 'get'
  })
}

export function updateOrgInfo (id, data) {
  return request({
    url: '/api/v1/organizations/' + id,
    method: 'put',
    data
  })
}

export function getLogisticsByOrgId (id) {
  return request({
    url: '/api/v1/organizations/' + id + '/logistics',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/organization.js